<template>
  <div class="">
    <StepHeader
      :title="title"
      :theme="theme"
    />

    <StepContent :theme="theme">
      <AppButtonList
        :buttons="buttons"
        :value="loanAmount"
        :theme="theme"
        @input="$_buttonList_handleInput(buttonListActionName, $event)"
      />
    </StepContent>

    <StepFooter hide-mobile>
      <AppButton
        :theme="theme"
        :loading="submitting"
        @click="$_loans_updateLead(updateLeadPayload, $_buttonList_dataLayerObject)"
      >
        Continue
      </AppButton>
    </StepFooter>
  </div>
</template>

<script>

import AppButton from '@/components/common/buttons/AppButton'
import AppButtonList from '@/components/common/buttons/AppButtonList'
import StepContent from '@/components/common/step-layout/StepContent'
import StepHeader from '@/components/common/step-layout/StepHeader'
import buttonList from '@/mixins/button-list'
import submitLoans from '@/mixins/submit/submit-loans'
import StepFooter from '@/components/common/step-layout/StepFooter'
import navigation from '@/mixins/navigation'
export default {
  // Name
  name: 'LoanAmount',

  // Components
  components: {
    AppButtonList,
    StepContent,
    StepHeader,
    StepFooter,
    AppButton
  },

  // Mixins
  mixins: [
    buttonList,
    submitLoans,
    navigation
  ],

  // Props
  props: {
    title: {
      type: String,
      default: 'How Much Would You Like to Borrow?'
    },

    theme: {
      type: String,
      default: 'blue'
    }
  },

  // Data
  data () {
    return {
      buttonListActionName: 'loans/setLoanAmount',
      buttonListFieldName: 'loanAmount',
      newButtonValues: [{
        text: '$500 - $3,000',
        dataLayer: '500to3000',
        value: '$500 - $3,000'
      }, {
        text: '$3,001 - $7,000',
        dataLayer: '3001to7000',
        value: '$3,001 - $7,000'
      }, {
        text: '$7,001 - $15,000',
        dataLayer: '7001to15000',
        value: '$7,001 - $15,000'
      }, {
        text: '$15,001 - $25,000',
        dataLayer: '15001to25000',
        value: '$15,001 - $25,000'
      }, {
        text: '$25,001 - $35,000',
        dataLayer: '25001to35000',
        value: '$25,001 - $35,000'
      }],
      oldButtonValues: [{
        text: 'Under $500',
        dataLayer: 'under500',
        value: 'Under $500'
      }, {
        text: '$500 - $1,500',
        dataLayer: '500to1500',
        value: '$500 - $1,500'
      }, {
        text: '$1,501 - $3,000',
        dataLayer: '1501to3000',
        value: '$1501 - $3000'
      }, {
        text: '$3,001 - $5,000',
        dataLayer: '3001to5000',
        value: '$3,001 - $5,000'
      }, {
        text: '$5,001 - $7,500',
        dataLayer: '5001to7500',
        value: '$5,001 - $7,500'
      }, {
        text: '$7,501 - $15,000',
        dataLayer: '7501to15000',
        value: '$7,501 - $15,000'
      }],
      buttonListDataLayerStepName: 'spring_ploan_loan_amount'
    }
  },

  // Computed
  computed: {
    loanAmount () {
      return this.$store.state.loans.loan_amount
    },

    updateLeadPayload () {
      return { loan_amount: this.loanAmount }
    },

    buttons () {
      return process.env.VUE_APP_UPDATE_LENDFUL_LOAN_AMOUNT ? this.newButtonValues : this.oldButtonValues
    }
  },

  // Watch
  watch: {
    $_navigation_triggerContinue: async function (val) {
      if (val) await this.$_loans_updateLead(this.updateLeadPayload, this.$_buttonList_dataLayerObject)
      this.$store.dispatch('setTriggerContinue', false)
    }
  }
}
</script>

<style scoped lang="scss">
</style>
